import React from "react"

import { Element } from "legacy/components/shared/base"

interface OwnProps {
  children?: string | null
  height: number
  overlap?: boolean
  spacing?: number
  width: number
}

type CurvedTextProps = OwnProps

const CurvedText: React.FC<CurvedTextProps> = ({
  children,
  height,
  overlap,
  spacing = 0,
  width,
}): React.ReactElement => {
  const diameter = width + spacing * 2
  const margin = overlap ? `-${height / 5}px` : "0"
  const radius = width / 2 + spacing / 2
  const viewBoxWidth = diameter + height * 2
  const viewBoxHeight = radius + height / 2
  const transform = `scale(${viewBoxWidth / width})`

  return (
    <Element m={`${margin} 0`} transform={transform} width="100%">
      <svg viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}>
        <path
          id="curve"
          fill="transparent"
          d={`M${height},${radius + height} A${radius},${radius} 0 0,1 ${
            diameter + height
          }, ${radius + height}`}
        />
        <text fill="currentColor" textAnchor="middle">
          <textPath xlinkHref="#curve" startOffset="50%">
            {children}
          </textPath>
        </text>
      </svg>
    </Element>
  )
}

export default CurvedText
